module.exports = __webpack_public_path__ + "img/pt.4802d69c.svg";